// This file was auto-generated by Fern from our API Definition.
import * as FernIr from "../../../../../index.mjs";
export const ReferencedRequestBodyType = {
    bytes: () => {
        return {
            type: "bytes",
            _visit: function (visitor) {
                return FernIr.dynamic.ReferencedRequestBodyType._visit(this, visitor);
            },
        };
    },
    typeReference: (value) => {
        return {
            value: value,
            type: "typeReference",
            _visit: function (visitor) {
                return FernIr.dynamic.ReferencedRequestBodyType._visit(this, visitor);
            },
        };
    },
    _visit: (value, visitor) => {
        switch (value.type) {
            case "bytes":
                return visitor.bytes();
            case "typeReference":
                return visitor.typeReference(value.value);
            default:
                return visitor._other(value);
        }
    },
};
